import React, { useState, useRef } from "react";
import { useSpring, animated } from "@react-spring/web";

const Collapsible = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);

  const toggleCollapsible = () => {
    setIsOpen(!isOpen);
  };

  // Animación del contenido colapsable
  const contentStyles = useSpring({
    height: isOpen ? contentRef.current?.scrollHeight : 0,
    opacity: isOpen ? 1 : 0,
    overflow: "hidden",
    config: { tension: 250, friction: 25 },
  });

  // Animación de la flecha
  const arrowStyles = useSpring({
    transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
    config: { tension: 250, friction: 25 },
  });

  return (
    <div style={{ marginBottom: "10px", borderBottom: "1px solid #ccc", padding: "10px" }}>
      <div
        onClick={toggleCollapsible}
        style={{
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span style={{ margin: 0, color: "#13816F", fontWeight: "bold", textDecoration: "underline" }}>{title}</span>
        <animated.div style={{ ...arrowStyles, display: "flex", alignItems: "center" }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            width="20px"
            height="20px"
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </animated.div>
      </div>
      <animated.div style={contentStyles}>
        <div ref={contentRef} style={{ paddingTop: "10px" }}>
          {children}
        </div>
      </animated.div>
    </div>
  );
};

export default Collapsible;